
<button
type="button"
placement="bottom"
class="btn  btn--paybee mdb-shared-popover shared-link shared-link--custom m-0"
[mdbPopover]="content"
(popoverShown)="onPopoverShown()"
(popoverHidden)="onPopoverHidden()"
trigger="click"
#popover="mdbPopover"
>
    <img _ngcontent-qxp-c242="" src="/img/svg/virtual-event/actions.svg" class="mdb-popover">
</button>


<ng-template #content>
    <div class="popover-links popover-links--aligned">
        <div
            class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
            [cdkCopyToClipboard]="getQRUrl(campaign)"
            (click)="onCopyToClipboard()"
        >
            <i class="far fa-copy mr-2"></i>
            <div>Copy Option Link</div>
        </div>
        <div
            class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
            (click)="shareFB(campaign)"
        >
            <i class="fab fa-facebook mr-2"></i>
            <div>Share on Facebook</div>
        </div>
        <div
            class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
            (click)="shareTwitter(campaign)"
        >
            <img src="img/svg/twiter-x.svg" style="width: 12px; margin-right: 5px;" class="mdb-popover">
            <div>Share on X</div>
        </div>
        <div
            class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
            (click)="onClickDownload()"
        >
            <i class="fas fa-download mr-2"></i>
            <div>QR Code</div>
    </div>
    </div>
</ng-template>
